import React, { useEffect, useState } from "react";
import { Popup } from "react-leaflet";
import { useSensorsMap } from "../../contexts/SensorsMapProvider.jsx";
import { typeDetails, getCardinalDirection } from "../../utils/sensors.js";
import PopupCloseHandler from "./PopupCloseHandler.jsx";

export default function SensorPopup({ sensors }) {
	const { dispatch, ACTIONS } = useSensorsMap();
	const [localSensors, setLocalSensors] = useState([]);

	useEffect(() => {
		const filteredSensors = sensors
			.filter(
				(sensor) =>
					sensor.value &&
					sensor.value !== "nd" &&
					sensor.value !== "nd_nd" &&
					typeDetails[sensor.type]
			)
			.sort((a, b) => typeDetails[a.type].pos - typeDetails[b.type].pos);

		setLocalSensors(filteredSensors);
	}, [sensors]);

	const getTextColor = (sensor) => {
		if (sensor.dan && sensor.dan < sensor.value) return "#ff0000";
		if (sensor.ale && sensor.ale < sensor.value) return "#d64f00";
		if (sensor.pre && sensor.pre < sensor.value) return "#b38e00";
		if (sensor.lvd) return "#6c757d";
		return "inherit";
	};

	return (
		<Popup>
			<PopupCloseHandler onClose={() => dispatch({ type: ACTIONS.CLEAR_SELECTED_SENSOR })} />
			<h3 className="text-center font-bold text-lg">
				{localSensors[0]?.name || "Sconosciuto"}
			</h3>
			<span className="block text-center text-sm text-gray-600 mb-4">
				{localSensors[0]?.lvd ? (
					<span className="italic text-orange-600">
						Dati aggiornati alle <br /> {localSensors[0].lvd}
					</span>
				) : (
					<span className="text-green-600">Stazione Online</span>
				)}
			</span>
			<div className="grid grid-cols-1 md:grid-cols-2 gap-2 w-32 md:w-64">
				{localSensors.map((sensor, idx) => {
					const {
						label,
						unit,
						short,
						icon: Icon,
						useCardinal,
					} = typeDetails[sensor.type];
					let valueDisplay = `${sensor.value} ${unit}`;
					const hasLvd = !!sensor.lvd;

					// Convert wind direction to cardinal if applicable
					if (useCardinal === true && sensor.value.includes("_")) {
						const [speed, direction] = sensor.value.split("_");
						valueDisplay = `${speed} ${unit} da ${getCardinalDirection(
							parseInt(direction, 10)
						)}`;
						return (
							<div
								key={idx}
								onClick={() =>
									dispatch({ type: ACTIONS.SET_SELECTED_SENSOR, payload: sensor })
								}
								className="cursor-pointer flex items-center gap-2"
								title={hasLvd ? "Ultimo aggiornamento: " + sensor.lvd : ""}
							>
								<Icon title="Direzione" style={{ fontSize: "24px" }} size={30} />
								<span
									style={{
										fontSize: "14px",
										fontWeight: hasLvd ? "" : "bold",
										fontStyle: hasLvd ? "italic" : "none",
										color: getTextColor(sensor), // Lighter text for lvd
									}}
								>
									{valueDisplay}
								</span>
							</div>
						);
					}

					return (
						<div
							key={idx}
							style={{ display: "flex", alignItems: "center", gap: "10px" }}
							onClick={() =>
								dispatch({ type: ACTIONS.SET_SELECTED_SENSOR, payload: sensor })
							}
							className="cursor-pointer"
							title={hasLvd ? "Ultimo aggiornamento: " + sensor.lvd : ""}
						>
							<Icon title={label} size={30} />
							{short && <span className="text-xs italic">{short}</span>}
							<span
								style={{
									fontSize: "14px",
									fontWeight: hasLvd ? "" : "bold",
									fontStyle: hasLvd ? "italic" : "none",
									color: getTextColor(sensor), // Lighter text for lvd
								}}
							>
								{valueDisplay}
							</span>
						</div>
					);
				})}
			</div>
		</Popup>
	);
}
